import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16ee6bc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Unit Types", -1))
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Size", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Total Units", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Available Units", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Pricing", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Description", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"max-width":"180px"} }
const _hoisted_10 = { style: {"max-width":"500px !important"} }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_14 = { key: 0 }

import { ref } from "vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitTypeInterface } from "@/types/unit";
import BaseSpinner from "@/components/BaseSpinner.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
  facilityName: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const status = ref("loading");

const unitTypes = ref(Array<UnitTypeInterface>());
const errors = ref("");



async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "loaded";
}
getUnitTypes();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("fieldset", null, [
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      (unitTypes.value)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _createElementVNode("tr", null, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              (__props.facilityName == 'ESS')
                ? (_openBlock(), _createElementBlock("th", _hoisted_8, "TPP Enabled"))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (unitType) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: unitType.id + 'unitType'
              }, [
                (__props.facilityName == 'ESS')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("td", _hoisted_9, [
                        (unitType.length != 0 && unitType.width != 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(unitType.length) + " x " + _toDisplayString(unitType.width) + " ", 1),
                              (unitType.name)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" - (" + _toDisplayString(unitType.name) + ") ", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(unitType.name), 1)
                            ], 64))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(unitType.total_unit_count), 1),
                      _createElementVNode("td", null, _toDisplayString(unitType.available_unit_count), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("td", null, _toDisplayString(unitType.size), 1),
                      _createElementVNode("td", null, _toDisplayString(unitType.total_units_count), 1),
                      _createElementVNode("td", null, _toDisplayString(unitType.available_units_count), 1)
                    ], 64)),
                _createElementVNode("td", null, "$" + _toDisplayString(Number(unitType.price).toFixed(2)), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(unitType.description), 1),
                (__props.facilityName == 'ESS')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                      (unitType.allow_tenant_protection)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_12
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_13
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})